<div class="number">
    <ng-content></ng-content>
</div>
<div class="stripe" [style.border-right-color]="color">&nbsp;</div>